module.exports = __webpack_public_path__ + "media/litigation_finance_101/cta-b85b9738.jpg";